/**
 * @generated SignedSource<<e9d01d7e7ca5dc065cb6357d8a7a5c50>>
 * @relayHash b98f4f5b287c78f1f3ffb27ad0ff0306
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 3f7a3f4aea8597c9d8377b481369e1bb4df020ca885fd40da31fec51d3070e51

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { JourneyConfigurationPageQuery } from './JourneyConfigurationPageQuery.graphql';

const node: PreloadableConcreteRequest<JourneyConfigurationPageQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "3f7a3f4aea8597c9d8377b481369e1bb4df020ca885fd40da31fec51d3070e51",
    "metadata": {},
    "name": "JourneyConfigurationPageQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
